var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8687 6.41875L18.2437 3.1375C18.1125 2.94062 17.9156 2.875 17.7188 2.875H14.4375V0.90625C14.4375 0.5125 14.175 0.25 13.7812 0.25H3.28125C2.8875 0.25 2.625 0.5125 2.625 0.90625V1.5625H3.28125C3.675 1.5625 3.9375 1.825 3.9375 2.21875C3.9375 2.6125 3.675 2.875 3.28125 2.875H2.625H1.96875C1.575 2.875 1.3125 3.1375 1.3125 3.53125C1.3125 3.925 1.575 4.1875 1.96875 4.1875H2.625H3.9375C4.33125 4.1875 4.59375 4.45 4.59375 4.84375C4.59375 5.2375 4.33125 5.5 3.9375 5.5H2.625H0.65625C0.2625 5.5 0 5.7625 0 6.15625C0 6.55 0.2625 6.8125 0.65625 6.8125H2.625V10.75C2.625 11.1438 2.8875 11.4062 3.28125 11.4062H3.34687C3.28125 11.2094 3.28125 10.9469 3.28125 10.75C3.28125 8.9125 4.725 7.46875 6.5625 7.46875C8.4 7.46875 9.84375 8.9125 9.84375 10.75C9.84375 10.9469 9.84375 11.2094 9.77812 11.4062H13.7812H13.8469C13.7812 11.2094 13.7812 10.9469 13.7812 10.75C13.7812 8.9125 15.225 7.46875 17.0625 7.46875C18.9 7.46875 20.3438 8.9125 20.3438 10.75C20.3438 10.9469 20.3438 11.2094 20.2781 11.4062H20.3438C20.7375 11.4062 21 11.1438 21 10.75V6.8125C21 6.68125 20.9344 6.55 20.8687 6.41875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.2ef1dc4f.svg";
export { ForwardRef as ReactComponent };